import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import type { components } from "../../../types/api.types";
import urls from "../../../urls";

export type TodoCalendarIntegration =
  components["schemas"]["TodoCalendarIntegration"];

export const todoCalendarIntegrationsQuery = {
  list: (variantId?: number) =>
    queryOptions({
      queryKey: ["todoCalendarIntegrations", variantId],
      queryFn:
        typeof variantId !== "undefined"
          ? () => fetchTodoCalendarIntegrations(variantId)
          : skipToken
    })
};

function useTodoCalendarIntegrations(variantId: number) {
  return useQuery(todoCalendarIntegrationsQuery.list(variantId));
}

async function fetchTodoCalendarIntegrations(variantId: number) {
  const response = await apiWithoutCamelization.get<TodoCalendarIntegration[]>(
    urls.api.todoCalendarIntegrations(variantId)
  );
  return response.data;
}

export { useTodoCalendarIntegrations };
